import { FaAngleDown, FaAngleUp } from "react-icons/fa6";
import type { AccordionProps } from "./interface";
import { useAccordion } from "./useAccordion";

export function Accordion({
  title,
  fields,
  values,
  defaultOpen = false,
  children,
  ...props
}: AccordionProps) {
  const { isOpen, setIsOpen } = useAccordion(defaultOpen);

  return (
    <div
      className="w-full border border-gray-300 rounded-lg bg-white"
      {...props}
    >
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="cursor-pointer w-full flex items-center justify-between p-4 text-left hover:bg-gray-50 transition-colors"
      >
        <h3 className="text-[14px] font-semibold">{title}</h3>
        {isOpen ? (
          <FaAngleUp className="w-5 h-5 text-[#68737D]" />
        ) : (
          <FaAngleDown className="w-5 h-5 text-[#68737D]" />
        )}
      </button>

      {isOpen && (
        <div className="border-t border-gray-200">
          {/* Campos principais do accordion */}
          {fields.map((field, index) => (
            <div
              key={index}
              className={`grid grid-cols-2 items-start text-[12px] ${
                index % 2 === 0 ? "bg-white" : "bg-[#F8F9F9]"
              }`}
            >
              <div className="text-sm text-[#87929D] py-[9px] px-4">
                {field}
              </div>
              <div className="text-sm py-[9px] px-4">{values[index]}</div>
            </div>
          ))}
          
          {/* Children (sub-accordions, botões, etc.) */}
          {children && (
            <div className="border-t border-gray-200">
              {children}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
